/**
* @Description 文件功能说明：manager主组件
* @Author CC
* @Time 2020/6/16
**/

/* HTML */
<template>
	<div class="sub-router-view">
		<!-- router-title-box start -->
		<div class="router-title-box" v-if="false">
			<div class="router-title-item">
				<a href="javascript:void(0);" class="router-title-back cursor-pointer" @click="closeRouter" title="返回首页"></a>
				<div class="router-title-tit">{{!$checkEmpty(routerSubName) ? routerSubName : ''}}</div>
			</div>
		</div>
		<!-- router-title-box end -->
		<div :class="{'router-view-box': true, 'router-view-index': showRoutNames.indexOf(routerSubName) != -1}">
			<router-view></router-view>
		</div>
	</div>
</template>

/* JS */
<script>
    
	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
        name: "ManagerApp",
        
        /**
		 * @Des 组件注册
		 * @Auth
		 * @Date 
		 */
        components: {
        	
        },// components
        
        /**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
        props: {
        	
        },// props
        
        /**
		 * @Des 数据定义
		 * @Auth
		 * @Date 
		 */
		data() {
			return {
				// 路由 子模块 name
				routerSubName: '',
				// 模块名称集合 展示title
				showRoutNames: [
					'首页'
				],
			}
		},// data
		
		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {
			
		},// created
		
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			// 开启订阅消息
			this.startSubscribes();
		},// mounted
		
		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			// 取消订阅消息
			this.endSubscribes();
		},// beforeDestroy
		
		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 
		 */
		destroyed() {
			
		},// destroyed
		
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 
		 */
		methods: {
			/**
			 * @Des 关闭路由 
			 * @Auth
			 * @Date 
			 */
			closeRouter () {
				// 路由 子模块 name
				this.routerSubName = '';
				// 跳转到 首页
            	this.$router.replace({path: this.$store.state.homePage}, ()=>{}, ()=>{});
			},// closeRouter

			//========================== 订阅消息 start ==========================
			/**
			 * @Des 开启订阅消息
			 * @Auth
			 * @Date
			 */
			startSubscribes() {
				// 订阅消息 路由 页
				this.sub_handleRouter = this.$pubsub.subscribe('routerSubName', (name, data) => {
					// 路由 子模块 name
					this.routerSubName = !this.$checkEmpty(data) ? data : '';
				});
			},
			/**
			 * @Des 取消订阅消息
			 * @Auth
			 * @Date
			 */
			endSubscribes() {
				//取消订阅 路由 页
				this.$pubsub.unsubscribe(this.sub_handleRouter);
			},
			
			/**
			 * @Des 点击条目
			 * @Auth
			 * @Date
			 */
			handleRouterBtn(routerSubName) {
				// 发布消息 路由 页
				this.$pubsub.publish('routerSubName', routerSubName);
			},
			//========================== 订阅消息 end ==========================
			
		},// methods
		
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {
			
		},// watch
		
		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {
			
		},// computed
		
    }// export default
</script>

/* CSS */
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/ManagerApp.vue